import { DataScope } from './../data-scope';
import { Page } from "../page"
import { SortOrder } from '../../interface/sort-order';
import { OrderQueryScopeEnum } from '../../enums/order-query-scope.enum';

export class PurchaseSearchParams extends Page {
  vendorNumbers: string[];
  facilitys: string[];
  adNos: string[];
  billOfLadings: string[];
  forwarder: string | null;
  importDeclarationNos: string[] | null;
  priorities: string[] | null;
  invoiceNos: string[] | null;
  docStatus: string[] | null;
  dataScopes: DataScope[];
  createDtStart: Date | null;
  createDtEnd: Date | null;
  userEmail: string | null;
  userType: string | null;
  roleCodes: string[] | null;
  orderQueryScope: string;
  pcsrAndCsrList: string[] | null;
  pageIndex: number | undefined;
  pageSize?: number | undefined;
  sortOrder: SortOrder;

  constructor() {
    super();
    this.vendorNumbers = [];
    this.facilitys = [];
    this.adNos = [];
    this.billOfLadings = [];
    this.forwarder = null;
    this.importDeclarationNos = [];
    this.priorities = [];
    this.invoiceNos = [];
    this.docStatus = null;
    this.dataScopes = [];
    this.createDtStart = null;
    this.createDtEnd = null;
    this.userEmail = null;
    this.userType = null;
    this.roleCodes = null;
    this.orderQueryScope = OrderQueryScopeEnum.all;
    this.pcsrAndCsrList = [];
    this.pageIndex = 0;
    this.pageSize = 5;
    this.sortOrder = {
      property: "facility",
      direction: -1
    };
  }
}
